import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/static/favorite-heart.svg'
import _imports_1 from '../../assets/static/favorite-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-05b52c83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-detail__buttons" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Icone de coração vermelho"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Adicionar aos favoritos ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Icone de coração branco"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Remover dos favoritos ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.bagIncludes(_ctx.product))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass([
        'product-detail__button-add',
        {
          'product-detail__button-blocked':
            _ctx.hasEnoughDecoins(_ctx.product) ||
            _ctx.isProductOutOfStock(_ctx.product) ||
            !_ctx.checkEnough(_ctx.product) ||
            _ctx.checkProductIsActive(_ctx.product),
        },
      ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addToBag(_ctx.product)))
        }, _toDisplayString(_ctx.setButtonText(_ctx.product)), 3))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "product-detail__button-remove",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeFromBag(_ctx.product)))
        }, " remover do carrinho ")),
    (!_ctx.isFavorite(_ctx.product))
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "card__favorite--unchecked",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.addToFavorites(_ctx.product)), ["stop"]))
        }, _hoisted_4))
      : (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "card__button-remove-favorite--checked",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.removeFromFavoriteList(_ctx.product)), ["stop"]))
        }, _hoisted_7))
  ]))
}